import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useUnitsList() {
  // Use toast
  const toast = useToast();

  const refUnitListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    //{ key: "id", label: "編號", sortable: true },
    { key: "name", stickyColumn: true, label: "單位名稱", sortable: true },
    { key: "sort_order", label: "排序", sortable: true },
    { key: "is_active", label: "狀態", sortable: true },
    { key: "updated_at", label: "修改時間", sortable: true },
    { key: "created_at", label: "創建時間", sortable: true },
    { key: "actions", label: "操作" },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("sort_order");
  const isSortDirDesc = ref(false);

  const dataMeta = computed(() => {
    const localItemsCount = refUnitListTable.value
      ? refUnitListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refUnitListTable.value.refresh();
  };

  const unitsList = ref([]);

  watch(
    [currentPage, perPage, searchQuery],
    () => {
      refetchData();
    }
  );

  const fetchProductUnits = (ctx, callback) => {
    store
      .dispatch("unit/fetchProductUnits", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then((response) => {
        const { product_units, total } = response.data;
        callback(product_units);
        totalRow.value = total;
        unitsList.value = product_units
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };
 


  onMounted(() => {
  });

  return {
    fetchProductUnits,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    unitsList,
    refUnitListTable,
    ability,
    refetchData,
  };
}
